import classNames from 'classnames';
import React from 'react';
import type { HTMLAttributes } from 'react';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends HTMLProps {
  title: string;
  strapline?: string;
  description?: React.ReactNode | string | null;
}

const Headline = React.forwardRef<Ref, Props>(({
  title,
  strapline,
  description = null,
  ...other
}: Props, ref): JSX.Element => (
  <div ref={ref} {...other as HTMLProps}>
    <div className={'flex items-center gap-2'}>
      <div className={`title uppercase text-sm font-bold md:text-lg ${classNames({ 'text-header': !!strapline })}`}>{title}</div>
      {strapline && (
        <div className={'text-sm font-bold'}>{strapline}</div>
      )}
    </div>
    {description && (
      <div className={'italic'}>
        {description}
      </div>
    )}
  </div>
));

Headline.displayName = 'Headline';

export default Headline;
